module.exports = __webpack_public_path__ + "img/beer_id-23.0cafabf3.png";